import React from 'react';
import LogIn from '../../components/authComponents/login';

const Page = () => <LogIn />;

export default Page;
